import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ProtectedRoute } from '../components/auth/index.js';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business QAレイアウト。VIEW_QA権限チェックを行いQA関連ページをラップ
 * @graph-connects ProtectedRoute [calls] 権限チェックコンポーネント呼び出し
 */
export const Route = createFileRoute('/qa')({
  component: QaLayout,
});

/** @graph-connects none */
function QaLayout() {
  return (
    <ProtectedRoute pageKey="qa">
      <Outlet />
    </ProtectedRoute>
  );
}
